var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmailCircleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24897_9205)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 29.5,
    fill: "white",
    stroke: "#DFF0EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0455 41.5057H21.8182V29.9148L15 24.8011V39.4602C15 40.5921 15.917 41.5057 17.0455 41.5057Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1818 41.5057H42.9545C44.0863 41.5057 44.9999 40.5887 44.9999 39.4602V24.8011L38.1818 29.9148",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1818 21.0513V29.9149L44.9999 24.8013V22.074C44.9999 19.5444 42.1124 18.1024 40.0909 19.6194",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8182 29.9148V21.0511L30.0001 27.1875L38.1819 21.0511V29.9148L30.0001 36.0511",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 22.074V24.8013L21.8182 29.9149V21.0513L19.9091 19.6194C17.8841 18.1024 15 19.5444 15 22.074Z",
    fill: "#C5221F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24897_9205"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailCircleLogo);
export default __webpack_public_path__ + "static/media/gmail_circle_logo.1bbcadd284dc6058a54739cce5964b89.svg";
export { ForwardRef as ReactComponent };